module.exports = __webpack_public_path__ + "img/thumb-009-27.f5af678d.png";